import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
// import { DoctorViewComponent } from './doctor-view.component';

@Injectable({
  providedIn: 'root'
})
export class FrontDeskService {

    private subject = new Subject<any>();
    // public doctor: DoctorViewComponent;
    constructor(public router:Router){}

    sendMessage(message: string) {
        this.subject.next(message);
        this.router.navigateByUrl("/FrontDesk");
        message == null;
    }

    clearMessages() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}
